export default __webpack_public_path__ + "assets/icon-home.21000ca5.webp";